export const LINK_DOWNLOAD_APP_PATIENT_PLAY =
  'https://play.google.com/store/apps/details?id=com.healthcare.sophie'
export const LINK_DOWNLOAD_PATIENT_STORE =
  'https://apps.apple.com/us/app/sophie-healthcare/id1637619161'
export const LINK_DOWNLOAD_APP_DOCTOR_PLAY =
  'https://play.google.com/store/apps/details?id=com.healthcare.sophie.doctor'
export const LINK_DOWNLOAD_DOCTOR_STORE =
  'https://apps.apple.com/us/app/sophie-doctor-healthcare/id1637619593'
export const IMAGE_BASE_URL = 'https://s3sophie.s3-ap-southeast-1.amazonaws.com'
